<template>
    <b-modal
        id="word_cloud-modal"
        ref="word_cloud-modal"
        centered
        :hide-header-close="true"
        :cancel-disabled="true"
        :ok-disabled="true"
        size="md"
        header-bg-variant="info"
        hide-footer
        hide-header
        class="border shadow-lg"
    >
        <div class="bg-white mt-1 text-center" v-if="data_cloud.question">
            <b-form-group 
                :label="data_cloud.question" 
                label-class="text-primary h5"
                v-slot="{ ariaDescribedby }"
                :state="wordsError?false:true"
                :invalid-feedback="wordsError"
                >
                <b-form-checkbox-group
                    v-if="data_cloud.json_options && data_cloud.json_options.length >0"
                    id="checkbox-word_cloud"
                    v-model="selected"
                    :options="data_cloud.json_options"
                    :aria-describedby="ariaDescribedby"
                    name="word_cloud"
                    class="pl-3 text-left"
                    stacked
                ></b-form-checkbox-group>
                <b-form-input
                    v-else
                    trim
                    type="text"
                    id="word"
                    v-model="word"
                    placeholder=""
                    :state="wordsError?false:true"
                    required
                    max="50"
                    @input="errors=[]"
                ></b-form-input>
            </b-form-group>
        </div>
        <template>
            <b-button-group class="float-right" size="md">
                <b-button :disabled="!isValid" @click="send" variant="success">
                enviar
                </b-button>
            </b-button-group>
        </template>
    </b-modal>
</template>
<script>

export default {
    name: 'WordCloud',
    data() {
        return {
            sent: false,
            form_disabled: false,
            selected: [], // Must be an array reference!
            word: null,
            errors: []
        }
    },
    props: {
        data_cloud: { 
            type: Object, default: () => ({
                question: null,
                json_options: [],
                key_id: null,
                goodby: null,
                name: null
            }), 
            required:true 
        },
        assistant: { type: Object, default: () => ({}), required:true },
    },
    methods: {
        setValue(value) {
            console.log(value)
        },
        send() {
            this.errors = []
            let loader = this.$loading.show()
            if((!this.data_cloud.json_options || this.data_cloud.json_options.length <=0) && this.word) this.selected[0] = this.word
            this.form_disabled = true
            this.$store.dispatch(
                'post', 
                {
                    'url': '/catalog/words/public_add_word', 
                    data: {
                        key_id: this.data_cloud.key_id,
                        assistant_key_id: this.assistant.key_id,
                        words: this.selected
                    }, 
                    headers:{}
                })
                .then((resp) => {
                    loader.hide()
                    this.form_disabled=false
                    this.sent = true
                    console.log(resp)

                    this.$nextTick(() => {
                        this.$emit(
                            'closed', 
                            {
                                'text': this.data_cloud.goodby,
                                'title': 'Aviso'
                            }
                        )
                    })
                })
                .catch(err => {
                    console.log(err.errors)
                    this.errors = err.errors
                    loader.hide()
                    this.form_disabled=false
                    //this.$emit('closed')
                })
        },
        showModal() {
            this.$bvModal.show('word_cloud-modal')
        },
    },
    beforeCreate () {
        
    },
    mounted() {
        console.log(this.data_cloud)
        this.showModal()
    },
    computed: {
        isValid: function() {
            if(this.wordsError) return false
            return true
        },
        wordsError: function () {
            if(this.data_cloud.json_options && this.data_cloud.json_options.length >0) {
                if(this.selected.length != 2) return "Debe seleccionar únicamente una opciones."
                return null
            } else if(this.errors && this.errors.words) return this.errors.words[0]
            return null
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../styles/app';
    
</style>